"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function ProductsCarouselConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <Carousel opts={{
      align: "start"
    }} className="w-full">
        <CarouselContent>
          {[...Array(4)].map((_, i) => <CarouselItem key={i} data-index={i} className="md:basis-1/2 lg:basis-1/3 pl-4">
              <Card className="rounded-sm border-none shadow-md overflow-hidden h-full">
                <CardContent className="p-4 flex flex-col gap-4 h-full">
                  <div className="w-full aspect-square bg-muted/20 animate-pulse rounded-sm" />
                  <div className="h-6 bg-muted/20 animate-pulse rounded-sm w-3/4" />
                  <div className="h-4 bg-muted/20 animate-pulse rounded-sm w-1/2" />
                  <div className="mt-auto h-10 bg-muted/20 animate-pulse rounded-sm w-full" />
                </CardContent>
              </Card>
            </CarouselItem>)}
        </CarouselContent>
      </Carousel>;
  }
  if (error || products.length === 0) {
    return <div data-section-id="155828" className="text-secondary-foreground/80 text-center p-8 bg-secondary-600/50 rounded-sm">
        <p>Derzeit sind keine Mietmaschinen in dieser Kategorie verfügbar.</p>
      </div>;
  }
  return <Carousel opts={{
    align: "start"
  }} className="w-full">
      <CarouselContent className="-ml-4">
        {products.map((product, i) => <CarouselItem key={product.id} data-index={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
            <Card className="rounded-sm border-none shadow-lg bg-card text-card-foreground h-full flex flex-col overflow-hidden transition-all hover:shadow-xl duration-300">
              <CardContent className="p-4 flex flex-col flex-grow gap-4">
                <Link to={product.link} className="block group">
                  <AspectRatio ratio={4 / 3} className="bg-muted rounded-sm overflow-visible">
                    {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="w-full h-full flex items-center justify-center bg-accent/10 text-accent">
                        <span className="text-xs font-mono font-medium">KEIN BILD</span>
                      </div>}
                  </AspectRatio>
                </Link>
                
                <div className="flex flex-col flex-grow">
                  <Link to={product.link} className="hover:text-primary transition-colors">
                    <h3 className="font-sans font-bold text-lg line-clamp-2 leading-tight uppercase tracking-tight">
                      {product.title}
                    </h3>
                  </Link>
                  
                  {product.price !== undefined && <div className="mt-2 mb-4">
                      <span className="text-xl font-mono font-bold text-primary">
                        €{product.price.toFixed(2)}<span className="text-xs text-muted-foreground font-normal ml-1">/ Tag</span>
                      </span>
                    </div>}
                  
                  <div className="mt-auto pt-4">
                    <AddToCartButton productId={product.id} variant="default" className="w-full" buttonClassName="bg-primary text-primary-foreground w-full rounded-sm font-sans font-bold uppercase tracking-wider shadow-md hover:bg-primary/90 transition-colors py-3" text="Maschine anfragen" showQuantity={false} />
                  </div>
                </div>
              </CardContent>
            </Card>
          </CarouselItem>)}
      </CarouselContent>
      <div className="hidden md:block">
        <CarouselPrevious className="bg-background text-foreground hover:bg-primary hover:text-primary-foreground border-none shadow-md -left-4 rounded-sm" />
        <CarouselNext className="bg-background text-foreground hover:bg-primary hover:text-primary-foreground border-none shadow-md -right-4 rounded-sm" />
      </div>
    </Carousel>;
}
export default function SalesBoost() {
  const wp_query_params = {
    per_page: 6,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return;
}